module.exports = __webpack_public_path__ + "static/media/Kyogre_gaussian2.276cc91d.png";